module.exports = __webpack_public_path__ + "img/jcyj_index.c3903fc2.jpg";